import React from 'react';
import { Modal } from 'react-bootstrap';

import MeasureDataEntryForm from '../shared/MeasureDataEntryForm';

function PreviewMeasureModal({ show, onCancel, data }) {

  return (
    <React.Fragment>
      {data?.fields ?
        <Modal
          dialogClassName="modal--full-width"
          show={show}
          centered
          onHide={onCancel}
        >
          <Modal.Header className="modal__header">
            <span>Preview</span>
            <button
              className="modal__header__btn"
              onClick={onCancel}
              aria-label="Exit"
            >
              X
            </button>
          </Modal.Header>

          <Modal.Body>
            <MeasureDataEntryForm data={data} onSubmit={onCancel} />
          </Modal.Body>
        </Modal> :
        <></>}
    </React.Fragment>

  )
}

export default PreviewMeasureModal;
